import React, { createContext, useContext } from 'react';
import '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';
import { hasProperties } from '@gov-nx/core/types';
import { sortAlphabetical } from '@gov-nx/utils/common';
import type { PageCode } from '../definitions/codes';
import type { ROSContext } from './context.types';
import { useRosExtendedQuery } from './useRosExtendedQuery';

const ProfilROSContext = createContext<Nullable<ROSContext>>(null);

interface SettingsROSContextProviderProps {
	children: React.ReactNode;
	code: PageCode;
}

export function RegistrOsobContextProvider({
	children,
	code,
}: SettingsROSContextProviderProps) {
	const {
		isLoading,
		error,
		extendedData,
		PFOData,
		POData,
		personInvolvementData,
	} = useRosExtendedQuery();

	return (
		<ProfilROSContext.Provider
			value={{
				code,
				controls: {
					initialLoading: isLoading,
					initialError: error,
				},
				extendedData,
				PFOData,
				POData: sortAlphabetical(
					'nazevSpolecnosti',
					POData.filter(hasProperties(['ico', 'nazevSpolecnosti']))
				),
				personInvolvementData: sortAlphabetical(
					'nazevSpolecnosti',
					personInvolvementData.filter(
						hasProperties(['ico', 'nazevSpolecnosti'])
					)
				),
			}}>
			{children}
		</ProfilROSContext.Provider>
	);
}

export const useProfilROSContextInstance = (): ROSContext =>
	useContext(ProfilROSContext) as ROSContext;
